module.exports = __webpack_public_path__ + "img/7e68658.png";